module.exports = __webpack_public_path__ + "img/溢洋茶府.2a5cfd6b.png";